import AttachmentType from 'owa-service/lib/contract/AttachmentType';
import { AttachmentState } from 'owa-attachment-full-data';
import { TypeOfAttachment } from 'owa-attachment-model-store';
import getAttachment from 'owa-attachment-model-store/lib/selectors/getAttachment';
import { isInvalidInlineAttachment } from 'owa-smime-adapter/lib/utils/smimeUtils';

/**
 * Returns S/MIME supported attachment types from attachments array
 * @param attachments Attachment list from Attachment well
 * @param bodyHTML is the mail body
 */
export default function getSmimeAttachments(
    attachments: AttachmentState[],
    bodyHTML: string
): AttachmentType[] {
    return attachments
        .map(attachment => {
            const attachmentModel = getAttachment(attachment.attachmentId);
            if (attachmentModel && attachmentModel.type !== TypeOfAttachment.Reference) {
                return attachmentModel.model;
            }
            return null;
        })
        .filter(
            // Remove null and unreferenced inline attachments
            attachment => !!attachment && !isInvalidInlineAttachment(bodyHTML, attachment)
        );
}
